import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";

const localeRoot = "pricing_plans.plan_settings.plan_selection.features";

export const TierHeaders = () => (
  <div className="mb-4 grid grid-cols-4">
    <Typography.LabelMd weight="semibold">
      {t([localeRoot, "usage"])}
    </Typography.LabelMd>
    <Typography.LabelMd weight="semibold">
      {t([localeRoot, "tiers", "professional"])}
    </Typography.LabelMd>
    <Typography.LabelMd weight="semibold">
      {t([localeRoot, "tiers", "business"])}
    </Typography.LabelMd>
    <Typography.LabelMd weight="semibold">
      {t([localeRoot, "tiers", "enterprise"])}
    </Typography.LabelMd>
  </div>
);
